import { Icon } from "@/components/atoms/icon";
import { cn } from "@/lib/utils";
import { StyledComponent } from "react-day-picker";

// Correct type: just return JSX.Element | null
export const IconLeft = ({
  className,
  ...rest
}: StyledComponent): JSX.Element | null => {
  return (
    <Icon
      icon="chevron-left"
      className={cn("block size-4 md:size-5", className)}
      {...rest}
    />
  );
};

export const IconRight = ({
  className,
  ...rest
}: StyledComponent): JSX.Element | null => {
  return (
    <Icon
      icon="chevron-right"
      className={cn("block size-4 md:size-5", className)}
      {...rest}
    />
  );
};

// DayContent
interface DayContentProps {
  date: Date;
  isToday?: boolean;
}

export const DayContent = ({
  date,
  isToday,
}: DayContentProps): JSX.Element | null => {
  return (
    <div className="relative flex items-center justify-center">
      <div className="h-4 w-5 text-xs md:h-5 md:w-6 md:text-sm">
        {date.getDate()}
      </div>
      {isToday && (
        <div className="absolute bottom-[-4px] h-1.25 w-1.25 rounded-full bg-[var(--fill-base-main)]" />
      )}
    </div>
  );
};
